export const callbackSite = `${location.origin}/account/callback`;
